import { CircularProgress, Link } from '@mui/material'
import { getInvoicingDocuments } from 'controllers/invoicing/index'
import { useState } from 'react'

interface InvoicingDocumentsDownloadLinkProps {
  disabled?: boolean
  vehicleGuid: string
}

export default function InvoicingDocumentsDownloadLink({ disabled, vehicleGuid }: InvoicingDocumentsDownloadLinkProps) {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

  return (
    <Link
      onClick={() => {
        if (disabled || isSubmitting || !vehicleGuid) return

        setIsSubmitting(true)
        getInvoicingDocuments([vehicleGuid]).finally(() => setIsSubmitting(false))
      }}
      sx={{ cursor: disabled ? 'not-allowed' : isSubmitting ? 'wait' : 'pointer' }}
    >
      {isSubmitting ? <CircularProgress size={16} /> : 'Download'}
    </Link>
  )
}
